import dayjs from "dayjs";
import { ROLES, type Role } from "../../../types/auth.types";

export interface MenuItem {
    id: string;
    label: string;
    auth?: (Role)[];
    to?: string | { [key in Role]?: string };
    children?: MenuItem[];
}

export const SIDE_MENU = [
    {
        id: "quotation",
        label: `${dayjs().format("YYYY-MM-DD")} 시세표 입력`,
        auth: [ROLES.OWNER, ROLES.PARTNER],
        to: "/quotation",
        children: []
    },
    {
        id: "account",
        label: "계정 관리",
        auth: [ROLES.ADMIN, ROLES.OWNER],
        to: "/account",
        children: []
    },
    {
        id: "branch",
        label: "지점 관리",
        auth: [ROLES.ADMIN, ROLES.OWNER, ROLES.PARTNER],
        to: "/branch",
        children: []
    },
    {
        id: "model",
        label: "기종 관리",
        auth: [ROLES.ADMIN],
        to: "/model",
        children: []
    },
    {
        id: "quotation",
        label: "지점별 시세표",
        auth: [ROLES.ADMIN],
        to: "/quotation",
        children: []
    },
    {
        id: "partner",
        label: "제휴 관리",
        auth: [ROLES.ADMIN],
        to: "/partner",
        children: []
    },
    {
        id: "userinfo",
        label: "마이페이지",
        auth: [ROLES.ADMIN, ROLES.OWNER, ROLES.PARTNER],
        to: "/userinfo",
        children: []
    },
];